import { getCookie } from './cookies';

export const COOKIE_NAME = 'isCookieNotificationSet';
export const COOKIE_VALUE = 'yes';

export const hasGivenCookieConsent = (): boolean =>
  getCookie(COOKIE_NAME) === COOKIE_VALUE;
